<template>
  <div class="dtf-add-to-cart">
    <div class="dtf-add-to-cart__submit-wrap">
      <button
        class="dtf-add-to-cart__button"
        type="button"
        :disabled="disableOrderButton"
        data-testid="dtf-add-to-cart-button"
        @mousedown.left="onMousedown"
        @click="onClick"
      >
        Add To Cart
      </button>
    </div>
    <ArtworkError v-if="spangleSizeEditing" :artwork="spangleErrorObject" />
  </div>
</template>

<script>
import { mapState, mapActions } from "pinia";
import ArtworkError from "./ArtworkError.vue";
import { useDtfStore } from "./store";
import { useSpanglesStore } from "./spangles-module";

export default {
  name: "DtfAddToCart",
  components: {
    ArtworkError
  },
  data() {
    return {
      submittedOnMousedown: false
    };
  },
  computed: {
    ...mapState(useDtfStore, [
      "artworks",
      "modalArtworks",
      "isReadyForOrder",
      "currentStore",
      "catalogNumber",
      "isSpangle",
      "removeBgLoading"
    ]),
    ...mapState(useSpanglesStore, [
      "spangleSizeEditing",
      "spanglesLoading",
      "spangleSizeEdited",
      "invalidSpangleSelected",
      "allAPIsCompleted"
    ]),
    disableOrderButton() {
      if (this.backgroundProcessesLoading) {
        return true;
      }

      if (this.isSpangle) {
        return (
          !this.isReadyForOrder ||
          this.spangleSizeEditing ||
          this.spanglesLoading ||
          !this.allAPIsCompleted ||
          !this.spangleSizeEdited ||
          this.invalidSpangleSelected
        );
      }
      return !this.isReadyForOrder;
    },
    spangleErrorObject() {
      return {
        errorMessage: "Please finish editing the size of the artwork before adding it to cart."
      };
    },
    backgroundProcessesLoading() {
      return this.removeBgLoading;
    }
  },
  watch: {
    disableOrderButton(disabled) {
      if (disabled) {
        this.submittedOnMousedown = false;
      }
    }
  },
  methods: {
    ...mapActions(useDtfStore, ["submitForm"]),
    // Submit on mousedown so the action runs before the dimension input's blur. Blur fires when
    // focus moves to the button and sets isPricingLoading, which disables the button before the
    // click event is processed—so a click-only handler would no-op when coming from the size field.
    onMousedown() {
      this.submittedOnMousedown = false;
      this.submitForm();
      this.submittedOnMousedown = true;
    },
    // Handles keyboard submit (Enter) and avoids double submit: a mouse click fires mousedown then
    // click, so we skip submit here when we already submitted in onMousedown. When the button
    // disables right after mousedown (blur from size field), the click never fires so the flag would
    // stay true and swallow the next keyboard submit—we clear it in a watcher when the button disables.
    onClick() {
      if (this.submittedOnMousedown) {
        this.submittedOnMousedown = false;
        return;
      }
      this.submitForm();
    }
  }
};
</script>

<style scoped lang="scss">
@import "frontend/init/jiffy/mixin.scss";
@import "frontend/init/jiffy/settings.scss";

.dtf-add-to-cart {
  &__submit-wrap {
    margin-bottom: 16px;
  }

  &__button {
    width: 100%;
    height: 52px;
    border-radius: 3px;
    font-weight: 700;
    border: 0;
    background-color: $red-light;
    color: $white;
    font-size: 24px;
    text-transform: uppercase;

    &:focus,
    &:hover {
      background-color: $red;
    }

    &:disabled {
      opacity: 0.4;
      pointer-events: none;
    }
  }
}
</style>
